// Import the functions you need from the SDKs you need
import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_APIKEY ||
    "AIzaSyBnSL9YfoHqmJIKRxvYM9kmzV9nMfJ2bvI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
};

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Initialize Firebase services
const auth = getAuth(app);

// Expose the instances we'll need
export { auth };
